//制造商部件
import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

import ManuFactPartPage from "@/views/model/manufacturerPart/ManuFactPartPage"; // 制造商部件
//import ManuFactPartTitleBlock from '@/views/model/manufacturerPart/ManuFactPartTitleBlock.vue' // 制造商部件
import ManuFactPartWhereUsed from "@/views/model/manufacturerPart/ManuFactPartWhereUsed.vue"; // 制造商部件
import ManuFactPartHistory from "@/views/model/manufacturerPart/ManuFactPartHistory.vue"; // 制造商部件

export const MFRP = {
  path: "/ManuFactPartPage",
  component: ManuFactPartPage,
  children: [
    {
      path: "/ManuFactPartRelationship",
      component: Relationship,
    },
    {
      path: "/ManuFactPartTitleBlock",
      // name: 'ManuFactPartTitleBlock',
      component: PageInfo,
    },
    {
      path: "/ManuFactPartAttachment",
      name: "ManuFactPartAttachment",
      component: ItemAttachment,
    },
    {
      path: "/ManuFactPartAttachment2",
      name: "ManuFactPartAttachment2",
      component: ItemAttachment,
    },
    {
      path: "/ManuFactPartWhereUsed",
      component: ManuFactPartWhereUsed,
    },
    {
      path: "/ManuFactPartHistory",
      component: ManuFactPartHistory,
    },
  ],
};
